"use client";

import { useLanguage } from "@/contexts/LanguageContext";
import type { PayLoadData } from "@/utils/payloadUtil";

interface LocalizedString {
  de: string;
  en: string;
}

interface DirectusTranslation {
  languages_code: string;
  [key: string]: any;
}

export function useTranslation() {
  const { language } = useLanguage();

  const t = (text: LocalizedString | string): string => {
    if (typeof text === "string") return text;
    return text[language];
  };

  const translatePayload = <T>(
    data: PayLoadData<T> | undefined,
    field: keyof T
  ) => {
    return (data?.[language]?.[field] as string) || "";
  };

  const translatePayloadCollection = <T>(
    data: PayLoadData<T[]> | undefined,
    field: keyof T
  ) => {
    return data?.[language]?.map((item) => item[field] as string) || [];
  };

  return {
    t,
    translatePayload,
    translatePayloadCollection,
  };
}
